var map = {
	"./X33-Mall_small.jpg": 907,
	"./all-active.svg": 908,
	"./all.svg": 909,
	"./apple-watch.png": 910,
	"./b-headphone.png": 911,
	"./coin.svg": 912,
	"./delete-btn.svg": 913,
	"./iphone-13.webp": 2314,
	"./iphone-pink.png": 914,
	"./love-active.svg": 915,
	"./love.svg": 916,
	"./mobile-bg.jpg": 917,
	"./mobile-bg.webp": 2315,
	"./price-high-active.svg": 918,
	"./price-high.svg": 919,
	"./price-low-active.svg": 920,
	"./price-low.svg": 921,
	"./rewards-dnp-cn.webp": 2316,
	"./rewards-dnp.webp": 2317,
	"./shopping-cart.svg": 922,
	"./star.svg": 923,
	"./x33mall-banner-cn.jpg": 924,
	"./x33mall-banner-cn.webp": 2318,
	"./x33mall-banner-id.jpg": 925,
	"./x33mall-banner-ms.jpg": 926,
	"./x33mall-banner-ms.webp": 2319,
	"./x33mall-banner.jpg": 927,
	"./x33mall-banner.webp": 2320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;